module Meevo.Plugins.GiftCardTypes {
    "use strict";

    import IBusyService = Meevo.Components.Busy.IBusyService;

    /**
    * Main Section of Gift Card Type 
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.GiftCardType> {
        isGiftCardTypeSold?: boolean;
        isGiftCardTypeUsedInPromotions?: boolean;
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            protected busyService: IBusyService,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected translateService?: angular.translate.ITranslateService,

        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey, translateService
            )   
        }

        sectionModelRetrieved() {
            this.checkIsSoldOrUsed();
        }

        isSoldOrUsed() {
            return this.isGiftCardTypeSold === true || this.isGiftCardTypeUsedInPromotions === true;
        }

        checkIsSoldOrUsed(): void {           
            if (this.model && this.model.id) {
                this.busyService.start();

                this.dataService.customMethodData(`api/giftCardType/${this.model.id}/usageValidation?timestamp=${Date.now()}`, 'GET', null).then((data: any) => {
                    this.isGiftCardTypeSold = data.data.isSold;
                    this.isGiftCardTypeUsedInPromotions = data.data.isUsedInPromoDiscount;
                    this.busyService.stop();
                });
            }
   
        }
        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

        /**
         * Event triggered when the defaultPrice input field is blurred.
         */
        onDefaultPriceBlurred(): void {
            this.model.valuePrice = this.model.defaultPrice;
        }

        createSectionModelCopy(): Model.GiftCardType {
            let item = <Model.GiftCardType>this.model;
            item.id = null;
            item.displayName = null;
            item.objectState = Model.ObjectStateEnum.Active;

            return item;
        }

        onIsPromoClicked() {
            if (Model.Guard.isSomething(this.model.isPromo)) {
                this.model.defaultPrice = 0.00;
            } else {
                this.model.serviceDetail = null;
                this.model.isPromoLiability = false;
            }
        }

        setValidMinDateFilter = (date: Date) => {
            let mindate = moment(date).startOf('day')

            if (this.model.id && mindate.isSame(moment(this.model.validFromDate).startOf('day'))) {
                return true;
            }

            let today = moment().startOf('day');
            let validToDate = this.model.validToDate ? mindate < moment(this.model.validToDate).startOf('day') : true;
            return (mindate >= today) && validToDate;
        }

        setValidMaxDateFilter = (date: Date) => {
            let tomorrow = moment().add(1, 'day').startOf('day');
            let maxDate = moment(date).startOf('day')
            let validFromDate = this.model.validFromDate ? maxDate > moment(this.model.validFromDate).startOf('day') : true;
            return (maxDate > tomorrow) && validFromDate;
        }

        preSave(): any {
            super.preSave()
        }

    }
}